import { memo } from 'react';
import createUseStyles from './create/index.js';
import { Transitions } from './enums/index.js';
import { j as jsxRuntimeExports } from './jsx-runtime-KJzvSKZ_.js';

var useStyles = createUseStyles({
  '@keyframes skeleton': {
    '100%': {
      transform: 'translateX(100%)'
    }
  },
  skeleton: {
    backgroundColor: function backgroundColor(props) {
      return props.backgroundColorStart;
    },
    borderRadius: function borderRadius(props) {
      return props.borderRadius;
    },
    position: 'relative',
    display: 'block',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    willChange: 'transform'
  },
  root: {
    position: 'absolute',
    inset: 0,
    transform: 'translateX(-100%)',
    willChange: 'transform',
    backgroundColor: function backgroundColor(props) {
      return props.backgroundColorStart;
    },
    backgroundImage: function backgroundImage(props) {
      return "linear-gradient(90deg, ".concat(props.backgroundColorStart, ", ").concat(props.backgroundColorEnd, ", ").concat(props.backgroundColorStart, ")");
    },
    animationName: '$skeleton',
    animationIterationCount: 'infinite',
    animationDuration: Transitions.Long
  }
}, {
  name: 'skeleton'
});

function Skeleton(_ref) {
  var _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? '' : _ref$borderRadius,
    _ref$backgroundColorS = _ref.backgroundColorStart,
    backgroundColorStart = _ref$backgroundColorS === void 0 ? 'var(--backgrounds-tint-2)' : _ref$backgroundColorS,
    _ref$backgroundColorE = _ref.backgroundColorEnd,
    backgroundColorEnd = _ref$backgroundColorE === void 0 ? 'var(--backgrounds-tint-3)' : _ref$backgroundColorE;
  var classes = useStyles({
    borderRadius: borderRadius,
    backgroundColorStart: backgroundColorStart,
    backgroundColorEnd: backgroundColorEnd
  });
  return /*#__PURE__*/jsxRuntimeExports.jsx("div", {
    className: classes.skeleton,
    children: /*#__PURE__*/jsxRuntimeExports.jsx("i", {
      className: classes.root
    })
  });
}
var Skeleton$1 = /*#__PURE__*/memo(Skeleton);

export { Skeleton$1 as S };
//# sourceMappingURL=Skeleton-iaHzVbrd.js.map
